import React from 'react';
import { __ } from '@wordpress/i18n';
import { isNil } from 'ramda';

// tools
import getDateTimeFromISOstring from '../../../../helpers/getDateTimeFromISOstring';
import getBandoLabel from '../../../../helpers/getBandoLabel';
import ChipWithIcon from '../../../../components/ChipWithIcon';
import { ticketsPriority } from '../../../../configData';

const TicketInfo = ({ data }) => {
    return (
        !isNil(data)
            ? <div className="appPageSection__withBorder columns">
                <p className="appPageSection__pMeta">
                    <span>{__('Nome User', 'htr')}</span>
                    <span>{data.supplierName}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Fornitore', 'htr')}</span>
                    <span>{data.companyName}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Priorità', 'htr')}</span>
                    <span>{ticketsPriority[data.priority]}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Creato', 'htr')}</span>
                    <span>{getDateTimeFromISOstring(data.createdDate)}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Aggiornato', 'htr')}</span>
                    <span>{getDateTimeFromISOstring(data.updatedDate)}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Stato', 'htr')}</span>
                    <span>{getBandoLabel(data.status)}</span>
                </p>
            </div> : null
    )
}

export default TicketInfo;